module.exports = "../dist/frontend/icons/logo/preloader.svg?3189ff3bab7416342ea1d338fdbcc917";